// Analytics event names. These are the canonical names dispatched from
// containers/components and consumed by analytics handlers (Reddit, Meta,
// GA4, ...). Reddit handler maps these to standard Reddit events where
// possible (SignUp, Search, ViewContent, PageVisit) and falls back to
// Custom for the rest. Keep names stable — they show up in Reddit Events
// Manager and downstream tools.
export const EVENT_LANDING_PAGE_VIEW = 'LandingPageView';
export const EVENT_SEARCH_PAGE_VIEW = 'SearchPageView';
export const EVENT_SEARCH_SUBMITTED = 'SearchSubmitted';
export const EVENT_SEARCH_FILTERS_CHANGED = 'SearchFiltersChanged';
export const EVENT_SEARCH_SORT_CHANGED = 'SearchSortChanged';
export const EVENT_SEARCH_RESULT_CLICKED = 'SearchResultClicked';
export const EVENT_CREATE_ACCOUNT_CLICKED = 'CreateAccountClicked';
export const EVENT_SIGNUP_COMPLETED = 'SignupCompleted';

// Module-level handler registry. Populated once at app boot in src/index.js
// (client only). On the server this stays empty so trackEvent is a no-op.
let registeredHandlers = [];

export const registerAnalyticsHandlers = handlers => {
  registeredHandlers = Array.isArray(handlers) ? handlers : [];
};

// Fire an analytics event to every registered handler.
//
// Resilience: each handler call is isolated — a thrown handler (e.g. the
// Reddit pixel script is blocked or rejects a payload) must not break the
// rest of the chain or the calling code.
export const trackEvent = (eventName, payload = {}) => {
  if (typeof window === 'undefined') return;
  if (!eventName) return;
  registeredHandlers.forEach(handler => {
    if (handler && typeof handler.trackEvent === 'function') {
      try {
        handler.trackEvent(eventName, payload);
      } catch (e) {
        // analytics must never break the app
      }
    }
  });
};

// Test helper — clears the registry between tests.
export const __resetAnalyticsHandlersForTests = () => {
  registeredHandlers = [];
};
